import React, { useEffect } from "react";
import {Link} from '@inertiajs/react';
import {Image} from "react-bootstrap";

const Navbar = () => {
  useEffect(() => {
    const handleScroll = () => {
      const elementId = document.getElementById("navbar");
      if (window.scrollY > 170) {
        elementId?.classList.add("sticky");
      } else {
        elementId?.classList.remove("sticky");
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg fixed-top"
      id="navbar"
    >
      <div className="container">
        <Link className="navbar-brand me-xl-5 me-3" href="/">
          <Image
            src="/images/landing/yv_logo.svg"
            alt="Young Voices"
            width={200}
            height={50}
          />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
